import React, { useEffect, useState } from 'react';
import Typography from '@components/typography';
import { useAppSelector } from '@hooks/statehooks';
import useToggleLiveChat from '@hooks/usetogglelivechat';
import ChevronDownIcon from '@components/chevrondownicon';
import cn from 'classnames';
import { TotalCostProps } from 'interface';
import { usePricing } from '@hooks/usepricing';
import { PricingType } from '../../../enums';
import { perMonthPriceInc, perMonthPriceExc } from '../../../constants';

const TotalCost: React.FC<TotalCostProps> = ({
  setShowCustomise,
  showCustomise,
  pricingType,
}) => {
  const { pricing } = useAppSelector((state) => state.vehiclePrice);
  const { updatePricing } = usePricing();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const { showElement, hideElement } = useToggleLiveChat();

  const handleDrawerToggle = () => {
    if (isDrawerOpen) {
      showElement();
    } else {
      hideElement();
    }
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    updatePricing(pricingType);
  }, []);

  const updateShowCustomise = () => {
    handleDrawerToggle();

    setShowCustomise(!showCustomise);
  };

  const scrollToPricingBreakdown = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingBreakdown =
      document.getElementsByClassName('pricingbreakdown')[0];
    pricingBreakdown.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={`total-cost ${showCustomise ? 'total-cost--show' : ''}`}>
      <div className="total-cost__row">
        <div className="total-cost__price">
          <Typography className="price__value" variant="currency" size="3x">
            {pricing && pricing.price.toLocaleString('en-GB')}
          </Typography>
          <Typography
            className="price__suffix"
            variant="caption"
            size="xs"
            data-cy="per-month-price-text"
          >
            {pricingType === PricingType.Personal
              ? perMonthPriceInc
              : perMonthPriceExc}
          </Typography>
        </div>
        <div className="total-cost__breakdown">
          <Typography className="price__total" variant="caption" size="rg">
            In total you'll pay&nbsp;
            <Typography
              className="price__total__value"
              variant="currency"
              size="rg"
            >
              {pricing && pricing.total.toLocaleString('en-GB')}
            </Typography>
          </Typography>
          <a href="#" onClick={scrollToPricingBreakdown}>
            <Typography
              className="price__breakdown"
              variant="caption"
              size="rg"
            >
              View pricing breakdown
            </Typography>
          </a>
        </div>
        <button
          type="button"
          className="total-cost__customise"
          onClick={updateShowCustomise}
        >
          <Typography variant="caption" size="sm" weight="semi-bold">
            Customise Your Lease
          </Typography>
          <span
            className={cn(
              'total-cost__customise__icon',
              showCustomise ? '' : 'total-cost__customise__icon__rotate'
            )}
          >
            <ChevronDownIcon />
          </span>
        </button>
      </div>
    </div>
  );
};

export default TotalCost;
